import { faGoogleDrive } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import styled from "styled-components";

export function DriveSearch({
  driveSearch,
}: {
  driveSearch: {
    url: string;
    color: string;
    text: string;
  };
}) {
  const [searchInput, setSearchInput] = useState("");

  const keyDownFunction = (event: any) => {
    if (event.key === "Enter") {
      console.log(searchInput);
      gdriveSearch(driveSearch.url, searchInput);
      setSearchInput("");
    }
  };

  return (
    <DriveSearchStyle $color={driveSearch.color} $text={driveSearch.text}>
      <Icon>
        <FontAwesomeIcon icon={faGoogleDrive} size="2xl" />
      </Icon>
      <Input
        value={searchInput}
        name="search"
        type="string"
        onChange={(e) => setSearchInput(e.target.value)}
        onKeyDown={keyDownFunction}
      ></Input>
    </DriveSearchStyle>
  );
}

const DriveSearchStyle = styled.div<{ $color: string; $text: string }>`
  background-color: ${(props) => props.$color};
  color: ${(props) => props.$text};
  height: 50px;
  width: 100%;
  margin: auto 0px;
  padding: 0px;
  align-items: center;
  border-radius: 25px;
  display: grid;
  grid-template-columns: 50px auto;
`;

const Icon = styled.div`
  height: auto;
  width: 50px;
  display: flex;
  justify-content: center;
  align-content: center;
`;

const Input = styled.input`
  all: unset;
  margin: 5px;
  height: 100%;
  width: 100%;
  font-weight: bold;
`;

function gdriveSearch(searchUrl: string, input: string) {
  const url = searchUrl + input;
  window.open(url)?.focus();
}
